import React from 'react';
import PropTypes from 'prop-types';
import { IonList, IonNote, IonItem, IonLabel } from '@ionic/react';
import { formatCurrency } from 'utils/currency';
import EmptyMenu from './EmptyMenu';
import MenuItem from './MenuItem';
import './MenuItemList.css';

function MenuItemList({ ticket, isTable, payType, myPrice, items, venue }) {
  if (!ticket || !venue) return null;

  const canPayItem =
    !venue.isFullPay && payType === `item` && !ticket.isPosPaymentMade;
  const payments = ticket.payments || [];

  return (
    <IonList>
      {items.length === 0 && <EmptyMenu isTable={isTable} />}
      {items.length > 0 && (
        <div className="ion-text-uppercase text-bold ml-2">Order Summary</div>
      )}
      {items &&
        items.map((item) => {
          return <MenuItem key={item.id} item={item} canPay={canPayItem} />;
        })}
      {!!ticket.totals && !!ticket.totals.discounts && (
        <IonItem lines="full">
          <IonLabel>
            <h3>Discounts</h3>
          </IonLabel>
          <IonLabel slot="end" className="menuitem-price">
            <h3>-{formatCurrency(ticket.totals.discounts)}</h3>
          </IonLabel>
        </IonItem>
      )}
      <IonItem lines="full">
        <IonLabel>
          <h3 className="text-bold">Subtotal</h3>
        </IonLabel>
        <IonLabel slot="end" className="menuitem-price">
          <h3 className="text-bold">
            {ticket.totals ? formatCurrency(ticket.totals.subTotal) : 0}
          </h3>
        </IonLabel>
      </IonItem>
      {payments.length > 0 && (
        <div className="ion-text-uppercase text-bold ml-2 mt-3x">
          Payments made
        </div>
      )}
      {payments.map((p) => (
        <IonItem key={p.id} lines="none">
          <IonLabel>Payment</IonLabel>
          <IonLabel slot="end" className="menuitem-price">
            {formatCurrency(p.amount)}
          </IonLabel>
        </IonItem>
      ))}
      {payments.length > 0 && (
        <IonItem lines="full">
          <IonLabel>
            <h3 className="text-bold">Remaining Balance</h3>
          </IonLabel>
          <IonNote slot="end" className="menuitem-price" color="primary">
            <h3 className="text-bold">
              {formatCurrency(
                ticket.totals.due -
                  ticket.totals.tax -
                  ticket.totals.serviceCharges
              )}
            </h3>
          </IonNote>
        </IonItem>
      )}
      <IonItem lines="full">
        <IonLabel>
          <h3>My Portion</h3>
        </IonLabel>
        <IonLabel slot="end" className="menuitem-price">
          <h3>{formatCurrency(myPrice)}</h3>
        </IonLabel>
      </IonItem>
    </IonList>
  );
}

MenuItemList.propTypes = {
  venue: PropTypes.object,
  ticket: PropTypes.object,
  isTable: PropTypes.bool,
  myPrice: PropTypes.number,
  payType: PropTypes.oneOf(['portion', 'item']),
  items: PropTypes.array,
};

export default MenuItemList;
